import { render } from "./InlineAccordion.vue?vue&type=template&id=d6e2a5dc&scoped=true"
import script from "./InlineAccordion.vue?vue&type=script&lang=js"
export * from "./InlineAccordion.vue?vue&type=script&lang=js"

import "./InlineAccordion.vue?vue&type=style&index=0&id=d6e2a5dc&scoped=true&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6e2a5dc"]])

export default __exports__